// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1n9sm","bigColWidth":"Table_bigColWidth__2fdew","biggerColWidth":"Table_biggerColWidth__3Veva","row":"Table_row__1DlW9","col":"Table_col__1DY0A"};